// src/components/CompanyProfile.js

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import CompanyProfileHeader from "./components/CompanyProfileHeader";
import CompanyInfo from "./components/CompanyInfo";
import CompanyButtons from "./components/CompanyButtons";
import { LoadingOverlay } from "../components/ui/loading-overlay";
import { fetchWithAuth } from "../Context/UserContext"; // Reutilizamos fetchWithAuth para las solicitudes autenticadas
import API_URL from "../config";
import { Helmet } from "react-helmet-async";


const CompanyProfile = () => {
  const { companyId } = useParams(); // Obtener el companyId de la URL
  const [company, setCompany] = useState(null); // Estado para guardar los datos de la empresa
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("perfil"); // Estado para manejar qué se muestra

  // Función para obtener el perfil de la empresa
  const fetchCompanyProfile = async (companyId) => {
    setIsLoading(true); // Iniciar el estado de carga
    setError("");
    try {
      const response = await fetchWithAuth(
        `${API_URL}/bs/company/${companyId}`,
        {
          method: "GET",
          public: true,
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCompany(data); // Guardamos los datos de la empresa
      } else {
        console.error("Error al cargar el perfil de la empresa");
        setError("No se pudo cargar el perfil de la empresa.");
      }
    } catch (error) {
      console.error("Error:", error.message);
      setError("No se pudo cargar el perfil de la empresa.");
    } finally {
      setIsLoading(false); // Finalizar el estado de carga
    }
  };

  useEffect(() => {
    if (companyId) {
      fetchCompanyProfile(companyId); // Llamar a la función para obtener el perfil de la empresa
    }
  }, [companyId]);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (error || !company) {
    return (
      <PageLayout>
        <div className="mx-auto max-w-4xl px-4 py-8 text-center text-sm text-destructive sm:px-6">
          {error || "No se pudo cargar el perfil de la empresa."}
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Helmet>
        <title>{company?.name ? `${company.name} - Perfil de Empresa | Procu` : "Perfil de Empresa | Procu"}</title>
        <meta
          name="description"
          content={company?.description ? company.description : "Consulta información detallada sobre esta empresa en Procu. Conéctate con proveedores y oportunidades de negocio."}
        />
        <meta name="keywords" content="empresa, perfil, proveedores, negocios, B2B, Procu" />
      </Helmet>

      <div className="mx-auto max-w-4xl space-y-6 px-4 py-8 sm:px-6">
        <CompanyProfileHeader companyDataProfile={company} />
        <CompanyButtons companyId={companyId} setActiveTab={setActiveTab} activeTab={activeTab} />
        <CompanyInfo companyData={company} activeTab={activeTab} />
      </div>
    </PageLayout>
  );
};

export default CompanyProfile;
